/**
 * One cap for every count badge: «99+», never «9+» (03.10.2026 re-score). The bell said «9+»
 * while the bottom bar said «52» for the same unread count on the same screen. A number wherever
 * a number fits; `badge-count.test.ts` fails on a hand-written cap anywhere else.
 */
export function formatBadgeCount(n: number): string {
  return n > 99 ? '99+' : String(n)
}
